"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ExpandableItem = _interopRequireDefault(require("./ExpandableItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SectionExpandableList = /*#__PURE__*/function (_Component) {
  _inherits(SectionExpandableList, _Component);

  var _super = _createSuper(SectionExpandableList);

  function SectionExpandableList(props) {
    var _this;

    _classCallCheck(this, SectionExpandableList);

    _this = _super.call(this, props);
    _this.top = /*#__PURE__*/_react["default"].createRef();
    _this.scrollToTop = _this.scrollToTop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SectionExpandableList, [{
    key: "scrollToTop",
    value: function scrollToTop() {
      this.top.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$sliceData = _this$props.sliceData,
          items = _this$props$sliceData.items,
          showBackToTop = _this$props$sliceData.primary.back_to_top,
          dataClient = _this$props.dataClient;
      var leftColItems = items.filter(function (item) {
        return !item.is_right_col;
      });
      var rightColItems = items.filter(function (item) {
        return item.is_right_col;
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "se-tier content-page__expandable-list"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "se-container",
        ref: this.top
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "se-row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "se-col se-col--12 se-col--6Tablet"
      }, leftColItems.map(function (item, idx) {
        return /*#__PURE__*/_react["default"].createElement(_ExpandableItem["default"], _extends({
          key: "expandable-left-".concat(idx),
          dataClient: dataClient
        }, item));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "content-page__expandable-list-hr content-page__expandable-list-hr--tablet"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "se-col se-col--12 se-col--6Tablet"
      }, rightColItems.map(function (item, idx) {
        return /*#__PURE__*/_react["default"].createElement(_ExpandableItem["default"], _extends({
          key: "expandable-right-".concat(idx),
          dataClient: dataClient
        }, item));
      }))), showBackToTop && /*#__PURE__*/_react["default"].createElement("button", {
        className: "content-page__expandable-list-to-top",
        type: "button",
        tabIndex: 0,
        onKeyPress: this.scrollToTop,
        onClick: this.scrollToTop
      }, "Back to top")));
    }
  }]);

  return SectionExpandableList;
}(_react.Component);

SectionExpandableList.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      is_right_col: _propTypes["default"].bool.isRequired
    })).isRequired,
    primary: _propTypes["default"].shape({
      back_to_top: _propTypes["default"].bool.isRequired
    }).isRequired
  }).isRequired
};
var _default = SectionExpandableList;
exports["default"] = _default;